import BaseApi from './BaseApi';
import { stringify } from 'qs';
import { DETAILS_RESOURCE_NAME, SENDERS_RESOURCE_NAME } from '../config/constants';

export default class CustomersApi extends BaseApi {
  static [`get${SENDERS_RESOURCE_NAME}`](params, cancelToken) {
    return this.get(`/customer/senders`, cancelToken);
  }

  static [`get${DETAILS_RESOURCE_NAME}`](params, cancelToken) {
    let queryParams = params ? `?${stringify(params)}` : null;

    console.log(
      '===',
      params
    );

    // api/customer/detail?sender=5196&from=2020-01-11&to=2020-02-12&type=MT&perPage=5&currentPage=750
    // params we have to have here
    // - sender
    // - from(2020-01-11%2000%3A00%3A00)
    // - to(2020-02-12%2000%3A00%3A00)
    // - type(MT/MO)
    // - perPage (optional)
    // - currentPage (optional)
      return this.get(`/customer/details${queryParams}`, cancelToken);
  }
  static [`download${DETAILS_RESOURCE_NAME}`](params,cancelToken){
    let queryParams = params ? `?${stringify(params)}` : null;
    return this.getFile(`/customer/details${queryParams}`, cancelToken);
  }
}
